module.exports = __webpack_public_path__ + "static/media/image.c33dab0c.jpg";